import api from "./api";

const patientService = {};
const endpoint = () => `/patients`;

patientService.create = function (patient) {
  return api
    .post(endpoint(), patient, arguments[1] || {})
    .then(({ data }) => data);
};

patientService.get = function (query) {
  return api
    .get(endpoint(), { params: query, sort: { lastName: 1, firstName: 1 } })
    .then((res) => res.data);
};

patientService.getById = function (id, options = {}) {
  return api.get(`${endpoint()}/${id}`, options).then((res) => {
    res.data.address = res.data.address || {};
    // res.data.medicalInsurance = res.data.medicalInsurance || {};
    // TODO DEFINE THIS
    const patientHealth = res.data.health || {};
    res.data.health = {
      ...patientHealth,
      allergies: patientHealth.allergies || [],
    };
    return res.data;
  });
};

patientService.getMe = function (userId) {
  const silentOptions = { getErrorMessage: () => null };
  return api
    .get(`${endpoint()}/me`, silentOptions)
    .then((res) => {
      res.data.address = res.data.address || {};
      const patientHealth = res.data.health || {};
      res.data.health = {
        ...patientHealth,
        allergies: patientHealth.allergies || [],
      };
      return res.data;
    })
    .catch(() => {
      return patientService.getById(userId, silentOptions);
    });
};

patientService.getPoints = function (id) {
  return api.get(`${endpoint()}/${id}/points`).then((res) => res.data);
};

patientService.update = function (patient) {
  return api
    .put(`${endpoint()}/${patient._id}`, patient, arguments[1] || {})
    .then(({ data }) => data);
};

// patientService.delete = function (id) {
//   return api.delete(`${endpoint()}/${id}`);
// };

patientService.getAggregates = function (params) {
  return api.get(`${endpoint()}/aggregates`, params).then((res) => res.data);
};

patientService.getPublicGroupById = function (publicGroupId) {
  return api
    .get(`${endpoint()}/public-group/${publicGroupId}`)
    .then((res) => res.data);
};

patientService.generatePDF = function (patientId, options = {}) {
  const params = {};
  if (options.includeIndications !== undefined) {
    params.includeIndications = options.includeIndications;
  }
  if (options.includeForms !== undefined) {
    params.includeForms = options.includeForms;
  }
  if (options.includePrograms !== undefined) {
    params.includePrograms = options.includePrograms;
  }

  return api.get(`${endpoint()}/${patientId}/generatePDF`, {
    params,
    responseType: "blob",
  });
};

export default patientService;
